import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Hint } from '@skbkontur/react-ui';
import classes from '../HomeAddress.module.css';
export const AddressEqualityCheckBox = ({ value, onValueChange, disabled }) => {
    const tooltipMessage = disabled ? 'Необходимо заполнить адрес регистрации' : null;
    return (_jsx(Hint, { pos: "right middle", text: tooltipMessage, children: _jsx(Checkbox, { checked: value, onValueChange: onValueChange, disabled: disabled, className: classes.check, "data-tid": "homeAddressCheckbox", children: "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439" }) }));
};
